import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/policy/img/block1_项目查询结果.png")